import { render, staticRenderFns } from "./LocationViewLogs.vue?vue&type=template&id=f4d87172"
import script from "./LocationViewLogs.vue?vue&type=script&lang=js"
export * from "./LocationViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports